<template>
  <div class="page-wrapper"   style="position: fixed; top:0; left:0; width: 100%; height: 100%; padding-top:0; color: #555;">
<!--    <div style="height: 50px; width: 100%;">-->
<!--      <a>Home</a>-->
<!--      <a>About Us</a>-->
<!--      <a>Order</a>-->
<!--      <a>Book</a>-->
<!--    </div>-->

    <template v-if="merchantItem != false && merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.enabled !== undefined && merchantItem.webSetting.enabled == 1">
      <div class="top-nav-container" id="main-nav">
        <div class="container-fluid" style="margin: auto;">
          <div class="row">
            <div class="col-12" style="display: flex; height: 50px;">
              <div style="width: 80px;">
                <a href="#home">
                  <img v-if="merchantItem.webSetting.icon !== null && merchantItem.webSetting.icon.length > 0" :src="merchantItem.webSetting.icon" style="height: 48px;">
                  <span v-else>{{merchantItem.title}}</span></a>
              </div>
              <div style="width: calc(100% - 80px);" id="nav-container">
                <div class="nav-icon-container" id="nav-icon" @click="clickedOnNavIcon">
                  <div class="bar1"></div>
                  <div class="bar2"></div>
                  <div class="bar3"></div>
                </div>
                <div class="web-nav">

<!--                  <a href="#order" v-if="merchantItem.webOrder == 1">ORDER</a>-->
                  <a href="#booking" class="hover-underline-animation" @click="clickedOnNavIcon" v-if="merchantItem.webSetting.useBooking === true">RESERVATION</a>
                  <a v-else-if="merchantItem.webSetting.bookingExtUrl !== null && merchantItem.webSetting.bookingExtUrl.length > 0" class="hover-underline-animation" :href="merchantItem.webSetting.bookingExtUrl">RESERVATION</a>
                  <a href="#menus" class="hover-underline-animation" @click="clickedOnNavIcon">MENUS</a>
                  <a href="#gallery" class="hover-underline-animation" @click="clickedOnNavIcon" v-if="merchantItem.webSetting.menuImages.length > 0">GALLERY</a>
                  <a href="#contact-us" class="hover-underline-animation" @click="clickedOnNavIcon">CONTACT US</a>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <div style="height: 100%; width: 100%; overflow-y: auto; scroll-behavior: smooth;" @scroll="handleScroll">
<!--        <div style="width: 100%; position: sticky; top:0; background: white;z-index: 10;">-->
<!--          <div class="container">-->
<!--            <div class="row">-->
<!--              <div class="col-12 text-left merchant-title">-->
<!--                {{merchantItem.title}}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
        <div style="width: 100%; position: relative; background-repeat: no-repeat; background-position: center; background-size: cover;"
            class="home-main-image" id="home">
          <!--             v-bind:style="{backgroundImage: 'url(' + merchantItem.webSetting.imageUrls.split(',')[0] +')'}"-->



          <slider animation="fade" style="height:100%" v-if="merchantItem.webSetting.imageUrls !== null && merchantItem.webSetting.imageUrls.length > 0">
            <slider-item
              v-for="(img, index) in merchantItem.webSetting.imageUrls"
              :key="index"
              style="z-index: 0; height:100%;"


            >
              <div class="restaurant-main-image" v-bind:style="{backgroundImage: 'url(' + img + ')'}"></div>
            </slider-item>
          </slider>

          <div class="home-main-overlay">
            <div  class="home-main-subtitle" style="position: absolute; top:50%; left: 50%; transform: translate(-50%, -50%);  ">
  <!--            <div style="width: 100%; text-align: center; color: white;font-size: 30px; line-height: 55px; font-weight: bold; text-shadow: 2px 2px 8px gray; padding-top:30px;">{{merchantItem.webSetting.topMessage}}</div>-->

              <div class="home-main-title-image"
                   v-if="merchantItem.webSetting.titleImage !== undefined && merchantItem.webSetting.titleImage !== null && merchantItem.webSetting.titleImage.length > 0">

                  <img :src="merchantItem.webSetting.titleImage"/>

              </div>
              <div class="home-main-title" v-else-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.topMessage !== null && merchantItem.webSetting.topMessage.length > 0">
                {{merchantItem.webSetting.topMessage}}
              </div>
              <div class="home-main-title" v-else>
                {{merchantItem.title}}
              </div>
              <div class="home-main-description" style="width: 100%; text-align: center; color: white; margin-top: 11px;">
                {{merchantItem.webSetting.topMessageSmall}}
              </div>
              <div v-if="merchantItem.webOrder == 1" style="width: 100%; text-align: center; margin-top: 60px; height: 50px;">
                <a :href="'/order/' + merchantItem.merchantId + '/takeaway'"><span class="home-main-order-btn">ONLINE ORDER</span></a>
              </div>
              <div v-if="merchantItem.webSetting.bookingExtUrl !== null && merchantItem.webSetting.bookingExtUrl.length > 0" style="width: 100%; text-align: center; margin-top: 60px; height: 50px;">
                <a :href="merchantItem.webSetting.bookingExtUrl"><span class="home-main-order-btn">RESERVATION</span></a>
              </div>
            </div>
          </div>
          <div style="position: absolute; bottom: 0; width: 100%; padding: 33px 0; text-align: center; background-color: #17161A; color: white;" v-if="merchantItem.webSetting.tempMessage !== null && merchantItem.webSetting.tempMessage.length > 0">
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <div class="editor-message" v-html="merchantItem.webSetting.tempMessage">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container" style="margin-top: 50px;">
          <div class="row">
            <div class="col-12 col-md-12 " style="display: flex;align-items: center;justify-content: center; padding-bottom: 0;">
              <!--                <div class="webpage-section-header text-center">-->
              <!--                  ORDER NOW-->
              <!--                </div>-->
              <!--                <div style="display: flex;align-items: center;justify-content: center; padding-bottom: 30px;" v-if="merchantItem.webOrder == 1" >-->
              <!--                  <a :href="'/order/' + merchantItem.merchantId + '/takeaway'">-->
              <!--                    <div style="border-radius: 25px; background-color: #E4E4E4; padding:30px;font-size: 1.5rem; font-weight: bold; box-shadow: 5px 5px 5px gray;">-->
              <!--                      Click & Collect-->
              <!--                    </div>-->
              <!--                  </a>-->
              <!--                </div>-->

              <a v-if="merchantItem.webSetting.uberUrl !== null && merchantItem.webSetting.uberUrl.startsWith('https://')"
                 :href="merchantItem.webSetting.uberUrl"
                 target="_blank">
                <img style="width: 80px; height: 80px; border-radius: 25px; margin: 10px;" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/uber-logo.png"/>
              </a>
              <a v-if="merchantItem.webSetting.deliverooUrl !== null && merchantItem.webSetting.deliverooUrl.startsWith('https://')"
                 :href="merchantItem.webSetting.deliverooUrl"
                 target="_blank">
                <img style="width: 80px; height: 80px; margin: 10px; border-radius: 25px;" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/deliveroo-logo.png"/>
              </a>

            </div>
          </div>
        </div>
        <div style="width: 100%; text-align: center;">
          <div class="id-tagger"  id="about-us"></div>
          <div class="container web-section" style="max-width: 1000px;">
<!--            <div class="row">-->
<!--              <div class="col-12">-->
<!--                <lottie-player src="https://assets4.lottiefiles.com/packages/lf20_vBDpbgb3YD.json" background="transparent"  speed="1"  style="width: 300px; height: 300px;" loop autoplay></lottie-player>-->

<!--              </div>-->
<!--            </div>-->
            <div class="row" v-if="merchantItem.webSetting.aboutUs !== null && merchantItem.webSetting.aboutUs.length > 0">
              <div class="col-12 text-center webpage-section-header">
                ABOUT US
                <div class="under-bar"></div>
              </div>
              <div class="col-12 webpage-section-content" style="padding-top: 28px;" v-html="merchantItem.webSetting.aboutUs.replace(/\n/g, '<br/>')">


<!--                <span style="color: #FF5733; font-size: 30px;"><i class="fas fa-quote-left"></i></span><br/>-->

<!--                <div style="padding-left: 30px;">-->

<!--                </div>-->
              </div>
            </div>
          </div>
          <div class="web-section gray-section" v-if="merchantItem.webSetting.useBooking === true">
            <div class="id-tagger"  id="booking"></div>
            <div class="container" >
              <template v-if="bookingType === 0">
                <booking-view
                  :merchant-item="merchantItem">

                </booking-view>
              </template>
              <template v-else-if="bookingType === 1">
                <booking-table-view
                  :merchant-item="merchantItem">

                </booking-table-view>
              </template>
<!--              <booking-view-->
<!--                :merchant-item="merchantItem">-->
<!--              </booking-view>-->
  <!--            <div class="row" v-if="bookingTypes.length > 1">-->
  <!--              <div class="col-12 booking-type-container" >-->
  <!--                <div class="booking-type" v-for="type in bookingTypes" v-bind:class="{'selected' : bookingItem.bookingType === type.title}" v-on:click="onTypeSelected(type.title)">-->
  <!--                  <div class="booking-type-title">-->
  <!--                    {{type.title}}-->
  <!--                  </div>-->
  <!--                  <div class="booking-type-description">-->
  <!--                    {{type.description}}-->
  <!--                  </div>-->
  <!--                </div>-->
  <!--              </div>-->
  <!--            </div>-->
  <!--            <div class="row booking-form-row">-->

  <!--              <div class="col-12 col-md-4">-->
  <!--                <input class="form-control" type="date" v-model="bookingItem.bookingDate" v-on:change="onBookingDateSelected"></input>-->
  <!--              </div>-->
  <!--              <div class="col-12 col-md-4">-->
  <!--                <select class="form-control" v-model="bookingItem.bookingTime">-->
  <!--                  <option value="0">Select Time</option>-->
  <!--                  <option v-if="bookingItem.slots.length > 0" v-for="slot in bookingItem.slots" :value="slot.time" :disabled="slot.available === false">{{slot.text}}  {{slot.available === false?' Full':''}}</option>-->
  <!--                </select>-->
  <!--              </div>-->

  <!--              <div class="col-12 col-md-4">-->
  <!--                <select class="form-control" v-model="bookingItem.headCount">-->
  <!--                  <option value="0">Number of people</option>-->
  <!--                  <option v-for="(c, ci) in 20" :value="c">{{c}} People</option>-->
  <!--                </select>-->
  <!--              </div>-->
  <!--              <div class="col-12 col-md-4">-->
  <!--                <input class="form-control" type="text" v-model="bookingItem.name" placeholder="Name">-->
  <!--              </div>-->
  <!--              <div class="col-12 col-md-4">-->
  <!--                <input class="form-control" type="text" v-model="bookingItem.contact" placeholder="Mobile Number">-->
  <!--              </div>-->
  <!--              <div class="col-12 col-md-4">-->
  <!--                <input class="form-control" type="text" v-model="bookingItem.email" placeholder="Email">-->
  <!--              </div>-->
  <!--              <div class="col-12 text-left">-->
  <!--                Special Request-->
  <!--                <textarea class="form-control" rows="3" v-model="bookingItem.note"/>-->
  <!--              </div>-->
  <!--              <div class="col-12 text-right" v-if="canSubmitBooking() == true">-->
  <!--                <button class="btn btn-dark" v-on:click="submitBooking">Submit</button>-->
  <!--              </div>-->
  <!--            </div>-->
            </div>
          </div>
<!--          <div class="container web-section" id="order" v-if="merchantItem.webOrder == 1 || (merchantItem.webSetting.uberUrl !== null && merchantItem.webSetting.uberUrl.startsWith('https://')) || (merchantItem.webSetting.deliverooUrl !== null && merchantItem.webSetting.deliverooUrl.startsWith('https://'))" >-->

<!--          </div>-->
          <div class="container web-section" >
            <div class="id-tagger"  id="menus"></div>
            <div class="row" v-if="merchantItem.webSetting.menu_type === '1'">
              <div class="col-12 webpage-section-header text-center">
                MENUS
                <div class="under-bar"></div>
              </div>
              <div class="col-12 even-item-container"  style="">
                <button class="restaurant-menu-button" v-on:click="showMenus('dineIn')">Restaurant Menus</button>
<!--              </div>-->
<!--              <div class="col-12 col-md-6">-->
                <button class="restaurant-menu-button"  v-on:click="showMenus('takeaway')">Takeaway Menus</button>
              </div>
            </div>
            <div class="row" v-else-if="merchantItem.webSetting.menu_type === '2' && merchantItem.webSetting.menu_urls !== undefined && merchantItem.webSetting.menu_urls !== null && merchantItem.webSetting.menu_urls.length > 0">
              <div class="col-12 webpage-section-header text-center">
                MENUS
              </div>
              <div class="col-12 even-item-container">
                <div v-for="menu in merchantItem.webSetting.menu_urls" class="restaurant-menu-button" style="margin-left:10px; margin-right: 10px;" @click="openMenuFile(menu.url)">
                  <strong>{{menu.title}}</strong>
                </div>
              </div>


            </div>
          </div>
          <div class="web-section dark-section" v-if="merchantItem.webSetting.menuImages.length > 0" >
            <div class="id-tagger"  id="gallery"></div>
            <div class="container" style="max-width: 1132px;">
              <div class="row">
                <div class="col-12">
                  <div class="webpage-section-header  text-center" >
                    GALLERY
                    <div class="under-bar white"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-md-4 web-gallery-item-container" v-for="img in merchantItem.webSetting.menuImages">
                  <div class="web-gallery-item" v-bind:style="{backgroundImage: 'url(' + getThumbnamil(img, '512') + ')'}"/>
                </div>
              </div>
            </div>
          </div>
          <div class="container web-section">
            <div class="id-tagger"  id="contact-us"></div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="webpage-section-header smaller text-left" >
                  Contact Us
                </div>
                <div class="place-bottom-container" style="text-decoration: underline;">
                  <a :href="'tel:' + merchantItem.contact">{{merchantItem.contact}}</a>
                  <br/>
                  <a :href="'http://maps.google.com/?q=' + merchantItem.address" target="_blank" >{{merchantItem.address}}</a>
                  <br/>


                  <!--            <span v-if="merchantItem.distance != undefined"><i class="fas fa-map-marker"></i> {{Number(merchantItem.distance).toFixed(1)}} miles</span>-->
                </div>
                <div class="place-bottom-container" v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.moreContact.length > 0" v-html="merchantItem.webSetting.moreContact">

                </div>
              </div>
              <div class="col-12 col-md-4">
                <!--                <div class="round-box" style="margin:auto;">-->
                <div class="webpage-section-header smaller text-left">
                  Opening Hours
                </div>
                <div class="body text-left place-bottom-container custom"
                     v-if="merchantItem.webSetting !== undefined &&
                      merchantItem.webSetting !== null &&
                      merchantItem.webSetting.openingHours !== null &&
                      merchantItem.webSetting.openingHours.length > 0"
                      v-html="merchantItem.webSetting.openingHours.replaceAll('p>', 'div>')">
                </div>
                <div v-else class="body text-left place-bottom-container">
                  <template  v-for="(day, di) in openingTime">
                    <div v-bind:key="'day-opening-hours-'+ di">
                      {{day.dayString}}:
                      <template v-if="day.open==false">
                        Closed
                      </template>
                      <template v-if="day.open == true && day.times != undefined && day.times.length > 0">
                        <span v-for="(time, ti) in day.times"><span v-if="ti>0">, </span>{{time.from}}~{{time.to}}</span>

                      </template>
                    </div>
                  </template>
<!--                  <table>-->
<!--                    <tr v-for="(day, di) in openingTime">-->
<!--                      <td style="width: 50%; vertical-align: top;">{{day.dayString}}</td>-->

<!--                      <td style="width: 50%; vertical-align: top; text-align: left;">-->
<!--                        <template v-if="day.open==false">-->
<!--                          Closed-->
<!--                        </template>-->
<!--                        <template v-if="day.open == true && day.times != undefined && day.times.length > 0">-->
<!--                          <span v-for="(time, ti) in day.times"><span v-if="ti>0">, </span>{{time.from}}~{{time.to}}</span>-->

<!--                        </template>-->
<!--                      </td>-->

<!--                    </tr>-->
<!--                  </table>-->
                </div>
                <!--                </div>-->
              </div>
              <div class="col-12 col-md-4">
                <div class="webpage-section-header smaller text-left">
                  Location
                </div>
                <div style="height: 300px;" id="mapName">
                  <iframe :src="merchantItem.webSetting.googleMap" width="100%" height="100%" frameborder="0" style="border:0"
                          allowfullscreen></iframe>
                </div>
              </div>
            </div>
            <div class="container" style="margin-top: 30px;" v-if="merchantItem.webSetting !== undefined && merchantItem.webSetting !== null && merchantItem.webSetting.bottomMessage !== null && merchantItem.webSetting.bottomMessage.length > 0">
              <div class="row">
                <div class="col-12" v-html="merchantItem.webSetting.bottomMessage">

                </div>
              </div>
            </div>
            <div class="container" style="margin-top: 50px; display: none;">
              <div class="row">
                <div class="col-12 col-md-12 " style="display: flex;align-items: center;justify-content: center; padding-bottom: 0;">


                    <a v-if="merchantItem.webSetting.uberUrl !== null && merchantItem.webSetting.uberUrl.startsWith('https://')"
                       :href="merchantItem.webSetting.uberUrl"
                       target="_blank">
                      <img style="width: 80px; height: 80px; border-radius: 25px; margin: 10px;" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/uber-logo.png"/>
                    </a>
                    <a v-if="merchantItem.webSetting.deliverooUrl !== null && merchantItem.webSetting.deliverooUrl.startsWith('https://')"
                       :href="merchantItem.webSetting.deliverooUrl"
                       target="_blank">
                      <img style="width: 80px; height: 80px; margin: 10px; border-radius: 25px;" src="https://storage.googleapis.com/menus-275719.appspot.com/icons/deliveroo-logo.png"/>
                    </a>

                </div>
              </div>
            </div>
          </div>

        </div>

        <div style="width: 100%; background-color: #ECECEC; margin-top:0;">
          <div class="container" style="max-width: 440px;">
            <div class="row" style="padding-top:20px;padding-bottom: 20px;">
              <div class="col-12 ">
                <div  v-if="(merchantItem.webSetting.facebook !== null || merchantItem.webSetting.facebook.length > 0) ||
                            (merchantItem.webSetting.instagram !== null || merchantItem.webSetting.instagram.length > 0) ||
                            (merchantItem.webSetting.youtube !== null || merchantItem.webSetting.youtube.length > 0)"
                      style="font-weight: bold; padding-top: 30px; padding-bottom: 10px;">
                  Follow Us
                </div>

                <div class="external-link" style="width: 100%; display: flex;align-items: center;justify-content: center; font-size: 50px; padding-bottom: 30px;">
                  <a v-if="merchantItem.webSetting.facebook !== null && (merchantItem.webSetting.facebook.startsWith('https://facebook.com') || merchantItem.webSetting.facebook.startsWith('https://www.facebook.com'))"
                     :href="merchantItem.webSetting.facebook" target="_blank">
                    <i class="fab fa-facebook"></i>
                  </a>

                  <a v-if="merchantItem.webSetting.instagram !== null && (merchantItem.webSetting.instagram.startsWith('https://www.instagram.com') || merchantItem.webSetting.instagram.startsWith('https://instagram.com'))"
                     :href="merchantItem.webSetting.instagram" target="_blank">
                    <i class="fab fa-instagram"></i>
                  </a>

                  <a v-if="merchantItem.webSetting.youtube !== null && (merchantItem.webSetting.youtube.startsWith('https://www.youtube.com') || merchantItem.webSetting.youtube.startsWith('https://youtube.com'))"
                     :href="merchantItem.webSetting.youtube" target="_blank">
                    <i class="fab fa-youtube"></i>
                  </a>
                </div>
              </div>
<!--              <div class="col-6 col-md-2 external-link" style="vertical-align: center; font-size: 30px; line-height: 50px;">-->
<!--                -->
<!--              </div>-->
<!--              <div class="col-6 col-md-2 external-link" style="vertical-align: center; font-size: 30px; line-height: 50px;">-->
<!--               -->
<!--              </div>-->

<!--              <div class="col-6 col-md-2 external-link" style="vertical-align: center; font-size: 30px; line-height: 50px;">-->
<!--               -->
<!--              </div>-->
              <!--              <div class="col-6 col-md-2" style="vertical-align: center; font-size: 30px; line-height: 50px;">-->
              <!--                <i class="fab fa-tiktok"></i>-->
              <!--              </div>-->
            </div>
            <div class="row">
              <div class="col-12 text-center" style="font-size: small;">
                <div style="width: 120px; margin:auto;">
                  <img style="width:80px;" :src="merchantItem.webSetting.icon"/>
                </div>
              </div>
              <div class="col-12 text-center" style="display: block;">
                <div>
<!--                  <template v-if="merchantItem.registeredTitle != undefined && merchantItem.registeredTitle != null && merchantItem.registeredTitle.length > 0">-->
<!--                    <strong>{{merchantItem.registeredTitle}}</strong> trade as-->
<!--                  </template>-->
                  <strong>{{merchantItem.title}}</strong><br>{{merchantItem.contact}}<br><span v-html="merchantItem.address.replace(/\n/g, '<br />')"></span>
                </div>

              </div>

              <!--              <div class="col-6 text-left tnc-btn" style="font-size:  x-small">-->
              <!--                <span v-on:click="openTnc">Terms & Conditions</span>-->
              <!--              </div>-->

              <div class="col-12" style="font-size:  small; margin-top:20px;">
                Copyright @{{copyRightYear}} <strong>{{merchantItem.title}}</strong>. All rights reserved
              </div>
              <div class="col-12"  style="font-size:  small; margin-top:20px;" v-if="merchantItem.webSetting.footerMessage !== null && merchantItem.webSetting.footerMessage.length > 0">
                <div v-html="merchantItem.webSetting.footerMessage"></div>
              </div>
              <div class="col-12" style="padding-top:20px; padding-bottom: 30px;">
                Powered by <strong>Show Me The Menu</strong>
                <br/>
                Borium Studio Limited
              </div>
              <!--              <div class="col-12" style="font-size:  x-small">-->
              <!--                Powered by <strong><span v-if="isEemo">EEMO & GOMO</span><span v-else>Show Me The Menu</span></strong>-->
              <!--                <template v-if="isEemo==false"><br>Borium Studio Limited</template>-->
              <!--              </div>-->

            </div>
          </div>
        </div>
      </div>


    </template>
    <div class="background-page" style="overflow-y: scroll; padding-top:0px;" v-else-if="commonDomain == false && merchantItem != false">
      <div class="place-container" :key="'m-'+merchantItem.merchantId" v-if="merchantItem.merchantId > 0">
        <div class="place-image-container" v-bind:style="{backgroundImage : 'url(' + merchantItem.imageUrl.split(',')[0] + ')'}">
          <div class="place-out-of-hours" v-if="merchantItem.isOpen == false">Out of opening hours</div>
        </div>

        <div class="place-info-container">
          <div class="place-header">
            <div class="place-title-container">
              {{merchantItem.title}}
            </div>
            <div class="place-service-container">
              <span v-if="merchantItem.webOrder == 1">Takeaway</span>
              <span v-if="merchantItem.webDelivery == 1">Delivery</span>
            </div>
          </div>

          <div class="place-tag-container">
            {{merchantItem.types}}
          </div>
          <div class="place-bottom-container">
            <i class="fas fa-map-marker"></i> <a :href="'https://maps.google.com/?q=' + merchantItem.address" target="_blank" >{{merchantItem.address}}</a>
            <br>
            <i class="fas fa-phone"></i> <a :href="'tel:' + merchantItem.contact">{{merchantItem.contact}}</a>
            <!--            <span v-if="merchantItem.distance != undefined"><i class="fas fa-map-marker"></i> {{Number(merchantItem.distance).toFixed(1)}} miles</span>-->
          </div>
          <div class="container">
            <div class="row">
              <div class="col-12" style="line-height: 80px;">
                Please choose the way you order
              </div>
            </div>
            <div class="row">
              <div class="col-4" v-for="menu in mainMenus" v-if="menu.enabled == true" v-on:click="moveToCustomSite(menu.mode)">
                <div class="square-icon" v-bind:style="{backgroundImage: 'url(' + menu.url + ')'}"></div>
                <div class="icon-title">{{menu.name}}</div>
              </div>

            </div>
          </div>
          <div class="round-box">
            <div class="header">
              Opening Hours
            </div>
            <div class="body">
              <table>
                <tr v-for="(day, di) in openingTime">
                  <td style="width: 35%;">{{day.dayString}}</td>

                  <td style="width: 65%;">
                    <template v-if="day.open==false">
                      Closed
                    </template>
                    <template v-if="day.open == true && day.times != undefined && day.times.length > 0">
                      <span v-for="(time, ti) in day.times"><span v-if="ti>0">, </span>{{time.from}}~{{time.to}}</span>

                    </template>
                  </td>

                </tr>
              </table>
            </div>
          </div>

        </div>


      </div>
      <Bottom :item="merchantItem"></Bottom>
    </div>
    <div class="background-page" style="overflow-y: scroll" v-else-if="commonDomain == true">
        <div class="map-view-container" style="display: none;">

        </div>
        <div class="container" style="padding-top:0px; padding-bottom:10px; position:sticky; top:0; background: #F1F1F1;z-index: 2">
          <div class="row">
            <div class="col-12 text-left" style="display: flex; padding-top:20px;">
                              <div class="mode-button" v-bind:class="{'selected': currentType=='takeaway'}" v-on:click="changeCurrentMode('takeaway')">Collect</div>
                              <div class="mode-button" v-bind:class="{'selected': currentType=='delivery'}" v-on:click="changeCurrentMode('delivery')">Delivery</div>


            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-4 col-lg-3" v-for="(merchant, index) in merchants"  :key="'m-'+index" v-if="merchant.merchantId != 1">
              <div class="place-container">
                <router-link :to="getPageLink(merchant)">
                  <div class="place-image-container" v-bind:style="{backgroundImage : 'url(' + merchant.imageUrl.split(',')[0] + ')'}">
                    <div class="place-out-of-hours" v-if="merchant.isOpen == false">Out of opening hours</div>
                  </div>
                  <div class="place-info-container">
                    <div class="place-header">
                      <div class="place-title-container">
                        {{merchant.title}}
                      </div>
                      <div class="place-service-container">
                        <span v-if="merchant.webOrder == 1">Takeaway</span>
                        <span v-if="merchant.webDelivery == 1">Delivery</span>
                      </div>
                    </div>

                    <div class="place-tag-container">
                      {{merchant.types}}
                    </div>
                    <div class="place-bottom-container">
                      {{merchant.contact}}
                    </div>
                    <div class="place-bottom-container">
                      {{merchant.address}}
                    </div>
                    <div class="place-bottom-container">
                      <span v-if="merchant.distance != undefined"><i class="fas fa-map-marker"></i> {{Number(merchant.distance).toFixed(1)}} miles</span>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>


        <div class="container-fluid eemo-yellow borium-black">
          <div class="row" style="padding-top:10px;padding-bottom: 10px;">


            <div class="col-12" style="font-size:  x-small">
              Copyright @{{Copyright}} <strong><span v-if="isEemo">EEMO & GOMO</span><span v-else>Show Me The Menu</span></strong>. All rights reserved
              <template v-if="isEemo == false"><br>Borium Studio Limited</template>
            </div>

            <div class="col-12" style="margin-top:15px;">
              <img style="width:25px; height:25px;" src="https://sj-eemo.s3.ap-northeast-2.amazonaws.com/web/logo-circle.png"/>
            </div>
          </div>
        </div>
    </div>
    <transition name="vertical">
      <div v-if="popupImage !== false && popupImage !== null && popupImage.length > 0"
           style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.4); z-index: 999;" @click="popupImage = false">
        <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: calc(100% - 30px); max-width: 500px; max-height: 90%; background: white; overflow-y: auto; box-shadow: 5px 5px 5px #333; border-radius: 20px;" @click.stop="dummy">
          <img :src="popupImage" style="width: 100%;"/>
          <div style="height: 50px; width: 100%; line-height: 50px; text-align: center; font-size: 20px; font-weight: bold;" @click.stop="popupImage = false">
            Close
          </div>
        </div>
      </div>
    </transition>
    <transition name="vertical">
      <div v-if="menuView != false" style="position: absolute; top:0; left: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.4); z-index:11;" v-on:click="menuView = false">
        <div style="position: absolute; width: calc(100% - 20px); max-width: 800px; height: calc(100% - 20px); top: 50%; left: 50%; transform: translate(-50%, -50%); background: white;" v-on:click.stop="dummy">
          <menu-view
            :merchant="menuView.merchant"
            :type="menuView.type"
            :on-close="closeMenuView"></menu-view>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
    import EventBus from "../api/event-bus";

    require('@/assets/css/styles.css')
    import {getMerchants, getMerchantMenus, getMerchantUrl, submitLog} from "../api/borium";
    import Router from '../router';
    import {Slider, SliderItem} from "vue-easy-slider";
    import Bottom from "./Bottom";
    import BookingView from "./BookingView";
    import BookingTableView from "./BookingTableView.vue";
    import MenuView from "./MenuView";
    export default {
        name: "Home",
        data() {
            return {
                commonDomain: true,
                animDuration: 300,

                currentType: 'all', //테이크아웃: 0, 방문예약: 1, 자동주문예약: 2, QR코드주문: 3

                currentMerchantItem: false, //매장정보

                bookingItem: false, //예약상세

                orderItem: false, //주문상세


                merchants:[],
                order:false,
                selectOrderItem: false,
                optionSelectItem: false,

              merchantItem:false,
              bookingType:-1,
              images:[],
              openingTime:[],
              deliveryTime:[],
                popup: {
                  show:false,
                  title:"",
                  message:'',
                  noBtnTitle:'',
                  yesBtnTitle:'',
                  noCb:null,
                  yesCb:null,

                },
                position:{
                    lat:0,
                    lng:0,
                },
              mainMenus: [
                {
                  name: "Collect",
                  url: "/static/img/ic-collect.png",
                  description: "Order and Collect.",
                  mode: 'takeaway',
                  enabled:true,
                },
                {
                  name: "Delivery",
                  url: "/static/img/ic-delivery.png",
                  description: "Simply order and We will deliver",
                  mode: 'delivery',
                  enabled:true,
                },
                {
                  name: "QRCode",
                  url: "/static/img/ic-qrcode.png",
                  description: "Simply scan QR Code on table.",
                  mode: 'qrCode',
                  enabled:true,
                },

                // {
                //     name:"자동주문 예약",
                //     url:"https://sj-eemo.s3.ap-northeast-2.amazonaws.com/web/ic-auto.png",
                //     description:"생활패턴에 맞춘 자동 주문해보세요.",
                //     mode:3,
                // },


              ],
              isEemo:false,

              menuView:false,
              scrollingPosition:0,
              popupImage: false,
              copyRightYear:'2025',

            }
        },
        components: {
          Slider,
          SliderItem,
          Bottom,
          BookingView,
          BookingTableView,
          MenuView,
        },
        created() {
          let date = new Date();
          this.$data.copyRightYear = date.getFullYear().toString();
            // console.log("Home created");
            if(window.location.host === 'eemo.app') {
              this.$data.isEemo = true;
            }
            $("#nav-top").removeClass("transparent-background");

            EventBus.$off('backPressed', this.backPressed);
            EventBus.$off('codeScanned', this.codeScanned);
            EventBus.$on('backPressed', this.backPressed);
            EventBus.$on('codeScanned', this.codeScanned);
            // if(window.location.host !== 'eemo.app' && window.location.host !== 'showmethemenu.net' && window.location.host !== 'localhost:8090' && window.location.host !== '10.0.100.3:8090') {
            if(window.location.host !== 'eemo.app' && window.location.host !== 'showmethemenu.net'){// && window.location.host !== '10.0.100.11:8090') {
              // console.log("Not common");
              this.$data.commonDomain = false;
            }
            this.getUUID();

            // registerBackKeyHandler(this.backPressed);
        },
        mounted() {

            EventBus.$emit("modeChanged", 0);
            EventBus.$emit("setTitle", "");
            // this.setPageMeta();
            this.updatePage();
            // console.log("Home mounted");
        },
        beforeDestroy() {
            // console.log("Home destroy");
            // registerBackKeyHandler(false);
            EventBus.$off('backPressed', this.backPressed);
            EventBus.$off('codeScanned', this.codeScanned);
        },
        watch: {
          // $route() {
          //   this.updatePage();
          // },
        },
        methods:{
            // setPageMeta: function() {
            //   const titleEl = document.querySelector('head title');
            //   const descEl = document.querySelector('head meta[name="description"]');
            //   const keywordsEl = document.querySelector('head meta[name="keywords"]');
            //
            //   titleEl.textContent = 'Show Me The Menu';
            //   descEl.setAttribute('content', "Kingston Local Food Takeaway and Delivery");
            //   keywordsEl.setAttribute('content', "Korea, Korean, Korean Food, Delivery, Takeaway, New Malden, Kingston, Kingston upon Thames, KFC, QRcode order, table QR, Table order, contactless order, Korean Chicken, London, London Korean");
            //
            // },
          dummy: function() {

          },
          clickedOnNavIcon: function() {
            document.getElementById("nav-container").classList.toggle("mobile-nav-show");
          },
          handleScroll(event) {
            // console.log(event.srcElement.scrollTop);
            if(this.$data.scrollingPosition < 300 && event.srcElement.scrollTop > 300) {

              if(document.getElementById("main-nav").classList.contains("dark") === false) {
                document.getElementById("main-nav").classList.add("dark");
              }
            } else if(this.$data.scrollingPosition > 300 && event.srcElement.scrollTop < 300) {
              if(document.getElementById("main-nav").classList.contains("dark") === true) {
                document.getElementById("main-nav").classList.remove("dark");
              }
            }
            this.$data.scrollingPosition = event.srcElement.scrollTop;
          },
            getUUID: function() {
              if(localStorage.getItem("UUID") == null) {
                let uuid = new Date().getTime();
                localStorage.setItem("UUID", uuid);
              }
              return localStorage.getItem("UUID");
            },
            updatePage: function() {
                // console.log("update page " + window.location.host);
                if(this.$data.commonDomain == false) {
                    let url = 'https://' + window.location.host;
                    if(window.location.host.startsWith('localhost') || window.location.host.startsWith("10.0.100.11")) {
                      // console.log("dev");
                      // url = 'https://gayauk.com';
                      url = 'https://sodaeng.co.uk';
                      // url = 'https://cahchi.co.uk';
                    }
                    // url = 'https://kappasushi.co.uk';
                    let self = this;
                    getMerchantUrl(url)
                      .then(function(data) {
                        // console.log(data);
                        if(data.success) {
                          if(data.item.webSetting !== undefined && data.item.webSetting !== null) {
                            if(data.item.webSetting.imageUrls !== undefined && data.item.webSetting.imageUrls !== null && data.item.webSetting.imageUrls.length > 0) {
                              data.item.webSetting.imageUrls = data.item.webSetting.imageUrls.split(",");
                            } else {
                              data.item.webSetting.menuImages = [];
                            }
                            if(data.item.webSetting.menuImages !== undefined && data.item.webSetting.menuImages !== null && data.item.webSetting.menuImages.length > 0) {
                              data.item.webSetting.menuImages = data.item.webSetting.menuImages.split(",");
                            } else {
                              data.item.webSetting.menuImages = [];
                            }

                            if(parseInt(data.item.webSetting.useBooking) == 1) {
                              data.item.webSetting.useBooking = true;
                            } else {
                              data.item.webSetting.useBooking = false;
                            }
                            if(data.item.webSetting.menu_urls !== undefined && data.item.webSetting.menu_urls !== null && data.item.webSetting.menu_urls.length > 0) {
                              data.item.webSetting.menu_urls = JSON.parse(data.item.webSetting.menu_urls);
                            } else {
                              data.item.webSetting.menu_urls = [];
                            }
                            if(data.item.webSetting.popupImage !== undefined && data.item.webSetting.popupImage !== null && data.item.webSetting.popupImage.length > 0) {
                              self.$data.popupImage = data.item.webSetting.popupImage;
                            }
                          }
                          self.$data.bookingType = parseInt(data.item.tableBooking);
                          // console.log("Booking type " + self.$data.bookingType);
                          self.$data.merchantItem = data.item;

                          self.setMerchant();
                        }
                      })
                      .catch(function(err) {
                        // console.log(err);
                      })

                  // setGTags('UA-184102860-1');
                  //
                  // this.loadGScript('UA-184102860-1');

                } else {
                  if (this.$route.query.hasOwnProperty('mode')) {

                    this.$data.currentType = this.$route.query.mode;
                    // this.getRestaurantList();


                  }
                  submitLog(0, 'Home', "")
                    .then(function(data) {

                    })
                    .catch(function(err){

                    })
                  this.getCurrentLocation();
                }

            },
            async loadGScript(id) {
              let recaptchaScript = document.createElement('script')
              recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?id=' + id)
              document.head.appendChild(recaptchaScript)
            },
            setMerchant: function() {
              EventBus.$emit("setTitle", this.$data.merchantItem.title);
              this.$data.images = this.$data.merchantItem.imageUrl.split(',');

              if(this.$data.merchantItem.webDelivery == 0) {
                this.$data.mainMenus[1].enabled = false;
              }
              if(this.$data.merchantItem.webTable == 0) {
                this.$data.mainMenus[2].enabled = false;
              }
              if(this.$data.merchantItem.webOrder == 0) {
                this.$data.mainMenus[0].enabled = false;
              }
              if(this.$data.merchantItem.openingTime != null && this.$data.merchantItem.openingTime.length > 3) {
                this.$data.openingTime = JSON.parse(this.$data.merchantItem.openingTime);
              }
              if(this.$data.merchantItem.deliveryTime != null && this.$data.merchantItem.deliveryTime.length > 3) {

                this.$data.deliveryTime = JSON.parse(this.$data.merchantItem.deliveryTime);
              }
              // const titleEl = document.querySelector('head title');
              // const descEl = document.querySelector('head meta[name="description"]');
              // const keywordsEl = document.querySelector('head meta[name="keywords"]');
              //
              // titleEl.textContent = merchantItem.title;
              //
              // let description = this.$data.merchantItem.title;
              // if(this.$data.merchantItem.types != null && this.$data.merchantItem.types.length > 0) {
              //   description += " " + this.$data.merchantItem.types;
              // }
              // if(this.$data.merchantItem.region != null && this.$data.merchantItem.region.length > 0) {
              //   description += " in " + this.$data.merchantItem.region;
              // }
              // descEl.setAttribute('content', description);
              //
              // let keys = "Takeaway, QRcode order, table QR, Table order, contactless order";
              // if(this.$data.merchantItem.tags != null && this.$data.merchantItem.tags.length > 0) {
              //   keys += "," + this.$data.merchantItem.tags;
              // }
              // keywordsEl.setAttribute('content', keys);

              this.setPageMeta();
              submitLog(this.$data.merchantItem.merchantId, 'MainPage', "")
                .then(function(data) {

                })
                .catch(function(err){

                })
            },
            setPageMeta: function() {
              const titleEl = document.querySelector('head title');
              const descEl = document.querySelector('head meta[name="description"]');
              const keywordsEl = document.querySelector('head meta[name="keywords"]');

              let title =this.$data.merchantItem.title;
              let key = this.$data.merchantItem.title;

              let description = "Simple click and collect order for " + this.$data.merchantItem.title;
              if(this.$data.merchantItem.region !== undefined && this.$data.merchantItem.region != null && this.$data.merchantItem.region.length > 0) {
                title += " in " + this.$data.merchantItem.region;
                key += "," + this.$data.merchantItem.region;
                description += " in " + this.$data.merchantItem.region;
              }
              key += ", takeaway";
              if(this.$data.merchantItem.tags !== undefined && this.$data.merchantItem.tags != null && this.$data.merchantItem.tags.length > 0) {
                key += "," + this.$data.merchantItem.tags;
              }
              title += " Takeaway | Menu | Price | Show Me The Menu";
              titleEl.textContent = title;

              descEl.setAttribute('content', description);
              keywordsEl.setAttribute('content', key);
              if(this.$data.merchantItem.webSetting !== undefined
                && this.$data.merchantItem.webSetting != null
                && this.$data.merchantItem.webSetting.icon != null
                && this.$data.merchantItem.webSetting.icon.startsWith("https://")) {
                let link = document.querySelector("link[rel~='icon']");
                if (!link) {
                  link = document.createElement('link');
                  link.rel = 'icon';
                  document.getElementsByTagName('head')[0].appendChild(link);
                }
                link.href = this.$data.merchantItem.webSetting.icon;
              }
            },
            calculateDistance: function(lat1, lon1, lat2, lon2, unit) {
                var radlat1 = Math.PI * lat1/180
                var radlat2 = Math.PI * lat2/180
                var radlon1 = Math.PI * lon1/180
                var radlon2 = Math.PI * lon2/180
                var theta = lon1-lon2
                var radtheta = Math.PI * theta/180
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                dist = Math.acos(dist)
                dist = dist * 180/Math.PI
                dist = dist * 60 * 1.1515
                if (unit=="K") { dist = dist * 1.609344 }
                if (unit=="N") { dist = dist * 0.8684 }
                return dist
            },
            reorderList: function() {

            },
            getCurrentLocation: function() {
              let self = this;

              if(navigator.geolocation) {
                // console.log("getting location");
                EventBus.$emit("showLoading", true, "Getting Location..");
                navigator.geolocation.getCurrentPosition(position => {
                  EventBus.$emit("showLoading", false);
                  // console.log("position");
                  // console.log(position);
                  self.$data.position.lat = position.coords.latitude;
                  self.$data.position.lng = position.coords.longitude;
                  self.getRestaurantList();
                }, error => {
                  EventBus.$emit("showLoading", false);
                  // console.log("Could not get position");
                  // console.log(error);
                  self.getRestaurantList();
                });
              } else {
                // console.log("No geolocation");
                this.getRestaurantList();
              }
            },
            backPressed: function(fromNav = false) {
                // console.log("backPressed " + this.$data.currentMode);

                if(this.$data.optionSelectItem != false) {
                    this.$data.optionSelectItem = false;
                    return true;
                }
                if(this.$data.currentMerchantItem != false) {
                    this.$data.currentMerchantItem = false;
                    return true;
                }
                // if(this.$data.currentMode >= 1 && this.$data.currentMode <= 4) {
                //     // console.log("currentMode back to 0");
                //     this.$data.currentMode = 0;
                //     EventBus.$emit("modeChanged", 0);
                //     return true;
                // }
                if(fromNav == true) {
                  // Router.push('/home');
                  history.go(-1)
                }
                return false;
            },
            moveToCustomSiteAnim: function(newMode) {
              setTimeout(this.moveToCustomSite, this.$data.animDuration, newMode);
            },
            moveToCustomSite: function(newMode) {
              if(newMode == 'qrCode') {
                EventBus.$emit("startScanner");
                return;
              }
              Router.push('/order/' + this.$data.merchantItem.merchantId + '/' + newMode);
            },
            startScanner: function() {
                EventBus.$emit("startScanner");
            },

            clickedOnYes: function() {
                this.$data.popup.show = false;
                if(this.$data.popup.yesCb != null) {
                  this.$data.popup.yesCb();
                }
                this.intialisePopup();

            },
            clickedOnNo: function() {
              this.$data.popup.show = false;
              if(this.$data.popup.noCb != null) {
                this.$data.popup.noCb();
              }
              this.intialisePopup();

            },
            clickedOnBackground: function() {
              this.intialisePopup();
            },

            intialisePopup: function() {
                this.$data.popup.show = false;
                this.$data.popup.title = '';
                this.$data.popup.message = '';
                this.$data.popup.yesBtnTitle = '';
                this.$data.popup.noBtnTitle = '';
                this.$data.popup.yesCb = null;
                this.$data.popup.noCb = null;
            },
            showPopup: function(title, message, yesBtnTitle = "Yes", noBtnTitle = "No", yesCb = null, noCb = null) {
                this.$data.popup.title = title;
                this.$data.popup.message = message;
                this.$data.popup.yesBtnTitle = yesBtnTitle;
                this.$data.popup.noBtnTitle = noBtnTitle;
                this.$data.popup.yesCb = yesCb;
                this.$data.popup.noCb = noCb;
                this.$data.popup.show = true;
                // console.log(this.$data.popup);
            },
            getRestaurantList: function() {
                let self = this;
                self.$data.merchants = [];
                getMerchants()
                    .then(function(data) {
                        if(data.success == true) {
                            //console.log("current type " + self.$data.currentType);
                            for(let i = 0 ; i < data.list.length ; i++) {

                              // console.log(data.list[i].title + " weborder " + data.list[i].webOrder + " webDelivery " + data.list[i].webDelivery);
                              if(data.list[i].webOrder == 0) {
                                continue;
                              }


                              if(self.$data.currentTyp !== 'all' && self.$data.currentType == 'takeaway' && data.list[i].webOrder == 0) {
                                continue
                              }
                              if(self.$data.currentTyp !== 'all' && self.$data.currentType == 'delivery' && data.list[i].webDelivery == 0) {
                                continue
                              }
                              if(data.list[i].webOrder == 0 && data.list[i].webDelivery == 0) {
                                continue;
                              }
                              if(self.getTodayOpeningTime(data.list[i]) == false) {
                                continue;
                              }
                              data.list[i].categories = [];
                              data.list[i].options = [];
                              data.list[i].priceSchedules = [];
                              data.list[i].discounts = [];
                              data.list[i].priceOptions = [];
                              if(data.list[i].imageUrl != null && data.list[i].imageUrl.length > 0) {
                                data.list[i].imageUrl = data.list[i].imageUrl.split(',')[0];
                              }
                              if(self.$data.position != false) {
                                data.list[i].distance = self.calculateDistance(self.$data.position.lat, self.$data.position.lng, data.list[i].lat, data.list[i].lng, 'M');
                              }

                              data.list[i].openingTime = JSON.parse(data.list[i].openingTime);
                              data.list[i].isOpen = false;
                              data.list[i].shopSlots = [];
                              if(data.list[i].openingTime != null && data.list[i].openingTime.length > 0) {
                                let today = new Date();
                                let currentTime = today.getTime();
                                let dayOfWeek = today.getDay();
                                let time = data.list[i].openingTime[dayOfWeek];

                                if(time != undefined && time != null) {
                                  // console.log(time);
                                  data.list[i].isShopOpen = time.open;


                                  if (data.list[i].isShopOpen == true && time.times != undefined && time.times != null && time.times.length > 0) {
                                    // this.$data.slots = time.times;

                                    for (let t = 0; t < time.times.length; t++) {

                                      let from = time.times[t].from;
                                      let to = time.times[t].to;


                                      today.setHours(Number(from.split(':')[0]));
                                      today.setMinutes(Number(from.split(':')[1]));

                                      let fromMil = today.getTime();

                                      today.setHours(Number(to.split(':')[0]));
                                      today.setMinutes(Number(to.split(':')[1]));

                                      let toMil = today.getTime();

                                      let slot = {
                                        from: fromMil,
                                        to: toMil,
                                        fromString: from,
                                        toString: to,
                                      };
                                      if(currentTime >= fromMil && currentTime < toMil) {
                                        data.list[i].isOpen = true;
                                      }
                                      // data.list[i].shopSlots.push(slot);
                                    }
                                  }
                                }
                              }
                              self.$data.merchants.push(data.list[i]);
                            }
                            self.$data.merchants.sort(function(a, b) {
                              if(a.distance != undefined && b.distance != undefined) {
                                if(a.distance < b.distance) {
                                  return -1;
                                } else if(a.distance > b.distance) {
                                  return 1;
                                }
                                return 0;
                              } else {
                                return 0;
                              }
                            })

                            // console.log(self.$data.merchants);
                        }
                    })
                    .catch(function(err) {
                      // console.log("ERR populating restaurants " + err);
                    })
            },
            changeCurrentModeAnim: function(newMode) {
                // console.log("changeCurrentModeAnim");
                setTimeout(this.changeCurrentMode, this.$data.animDuration, newMode);
            },
            changeCurrentMode: function(newMode) {
                // console.log("changeCurrentMode");
                if(this.$data.currentMode == newMode) {
                    return;
                }
                // EventBus.$emit("modeChanged", 1);

                let url = '/home?mode=' + newMode;
                Router.push(url);
                // if(newMode == 4) {
                //     this.startScanner();
                // } else {
                //   this.$data.currentMode = newMode;
                //   this.getRestaurantList();
                // }

            },


            codeScanned: function(code) {
                // console.log("code Scanned " + code)
                // let obj = JSON.parse(code);
                // if(obj != null) {
                //     if(obj.tableId != undefined) {
                //         Router.push('/restaurant?table='+obj.tableId);
                //     }
                // }
                window.location.href = code;
            },
            /**
             * Open / Select Restaurant
             * Select -> Get menus -> Sort menus
             * @param merchant
             */
            merchantSelectedAnim: function(merchant) {
                setTimeout(this.merchantSelected, this.$data.animDuration, merchant);
            },
            getPageLink: function(merchant) {
              if(this.$data.currentType === 'all') {
                return '/place/' + merchant.merchantId;
              }
              let route = '/restaurant/'+merchant.merchantId;
              if(this.$data.currentType == 'takeaway') {
                route += '/takeaway';
              } else if(this.$data.currentType == 'delivery') {
                route += '/delivery';
              }
              return route;
            },
            merchantSelected: function(merchant) {

                if(this.$data.currentType === 'all') {
                  if(merchant.orderUrl != null && merchant.orderUrl.startsWith('http')) {
                    window.location.href = merchant.orderUrl;
                  } else {
                    Router.push('/place/' + merchant.merchantId);
                  }
                  return;
                }
                let route = '/restaurant/'+merchant.merchantId;
                if(merchant.orderUrl != null && merchant.orderUrl.startsWith('http')) {
                  route = merchant.orderUrl + '/order/' + merchant.merchantId;
                }
                if(this.$data.currentType == 'takeaway') {
                  route += '/takeaway';
                } else if(this.$data.currentType == 'delivery') {
                  route += '/delivery';
                }
                if(merchant.orderUrl != null && merchant.orderUrl.startsWith('http')) {
                  window.location.href = route;
                } else {
                  Router.push(route);
                }


            },
            getMenus: function(merchantId) {
                let self = this;
                getMerchantMenus(merchantId)
                .then(function(data) {
                    if(data.success == true) {
                        if(data.list != undefined) {
                            self.populateMenus(data.list);
                        }
                    }
                })
                .catch(function(err) {

                })
            },
            populateMenus: function(list) {
                this.$data.currentMerchantItem.categories = [];
                this.$data.currentMerchantItem.options = [];
                this.$data.currentMerchantItem.priceSchedules = [];
                this.$data.currentMerchantItem.discounts = [];
                this.$data.currentMerchantItem.priceOptions = [];


                for(let i = 0 ; i < list.length ; i++) {
                    if(list[i].content != null && list[i].content.length > 0) {
                        list[i].content = JSON.parse(list[i].content);
                    }
                    if(list[i].type === 'public_category') {
                        if(list[i].list != null && list[i].list.length > 0) {
                            for (let j = 0; j < list[i].list.length; j++) {
                                if(list[i].list[j].content != null && list[i].list[j].content.length > 0) {
                                   list[i].list[j].content = JSON.parse(list[i].list[j].content);
                                }
                            }
                        }
                        this.$data.currentMerchantItem.categories.push(list[i]);
                    } else if(list[i].type === 'option') {
                        this.$data.currentMerchantItem.options.push(list[i]);
                    } else if(list[i].type === 'price_schedule') {
                        this.$data.currentMerchantItem.priceSchedules.push(list[i]);
                    } else if(list[i].type === 'discount') {
                        this.$data.currentMerchantItem.discounts.push(list[i]);
                    } else if(list[i].type === 'price_option') {
                      this.$data.currentMerchantItem.priceOptions.push(list[i]);
                    }
                }
                // console.log(this.$data.currentMerchantItem);

            },
            selectMenu: function(item) {


                // console.log("select Menu");
                // console.log(item);
                let orderItem = {
                    id:0,
                    parent_id:0,
                    record_type:4,
                    item_type: 0,
                    menu_name: item.name,
                    menu_id: item.id,
                    amount:1,
                    price: Number(item.price),
                    original_price: Number(item.price),
                    total_price: Number(item.price),
                    tax_rate: Number(item.tax_rate),
                    tax_amount:0,
                    discount_amount:0,
                    option_selection:[],
                    ordered_amount:0,
                    order_date:'',
                    order_time:'',
                    customer_index:0,
                    subscription_id: this.$data.currentMerchantItem.merchantId,
                    description: JSON.parse(JSON.stringify(item.content)),
                    notify_kitchen: item.notify_kitchen,
                    notify_bar: item.notify_bar,
                    as_main: 0,
                    optionPrice:0,
                    options:[],
                }

                if(this.$data.order == false || this.$data.order.list.length == 0) {
                    orderItem.id = 1;
                } else {
                    orderItem.id = this.$data.order.list.length;
                }
                if(item.content != null) {
                    // let content = JSON.parse(item.content);

                    // console.log(item.content);
                    if(item.content.options != undefined) {
                        //Check if option needs to be selected
                        if(this.shouldShowOptionSelectionView(orderItem) == true) {
                            //Show Option View
                            // console.log("should show option view");
                            return;
                        }
                    }
                }

                if(item.public_name != null && item.public_name.length > 0) {
                    orderItem.menu_name = item.public_name;
                }
                this.addOrderItem(orderItem);


            },
            changeItemAmount: function(index, diff) {
                this.$data.order.list[index].amount += diff;
                this.$data.order.list[index].total_price = this.$data.order.list[index].price*this.$data.order.list[index].amount;
                this.calculatePrice();
            },
            addOrderItem: function(item) {
                if(this.$data.order == false) {
                    this.$data.order = {
                        list:[],
                        id:0,
                        menu_name:'remote',
                        price: item.price,
                        original_price: item.price,
                        ordered_amount: 0,
                        total_price: 0,
                        tax_amount:0,
                        tax_rate:0,
                        service_charge_rate:0,
                        service_charge_amount:0,
                        total_due:0,
                        subscription_id: this.$data.currentMerchantItem.merchantId,
                        useSms: this.$data.currentMerchantItem.useSms,
                        useEmail: this.$data.currentMerchantItem.useEmail

                    }

                }
                if(this.checkIfSame(item) == false) {
                   this.$data.order.list.push(item);
                }
                this.calculatePrice();

            },
            checkIfSame: function(item) {
                // console.log("checkIfSame");
                if(this.$data.order == false) {
                    return false;
                }
                if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
                    return false;
                }
                for(let i = 0 ; i < this.$data.order.list.length ; i++) {
                    if(this.$data.order.list[i].menu_id == item.id) {


                        // console.log("item");
                        // console.log(item);
                        // console.log("from list");
                        // console.log(this.$data.order.list[i]);
                        if(this.$data.order.list[i].ordered_amount > 0) {
                          // console.log("ordered amount")
                          continue;
                        }
                        if(this.$data.order.list[i].menu_name !== item.menu_name) {
                            // console.log("menu name")
                            return false;
                        }
                        if(this.$data.order.list[i].public_menu_name !== item.public_menu_name) {
                          // console.log("public_menu_name")
                          return false;
                        }
                        if(this.$data.order.list[i].price != item.price) {
                          // console.log("price")
                          return false;
                        }
                        if(this.$data.order.list[i].optionPrice != item.optionPrice) {
                          // console.log("optionPrice")
                          return false;
                        }

                        if(this.$data.order.list[i].options.length != item.options.length ) {
                          // console.log("options")
                          return false;
                        }

                        if(JSON.stringify(this.$data.order.list[i].options) !== JSON.stringify(item.options)) {
                          return false;
                        }

                        /**
                         * the same menu
                         */
                        this.itemAmountChanged(item.amount, i);
                        return true;

                    }


                }
                return false;
            },
            calculatePrice: function() {
                let totalPrice = 0;
                for(let i = 0 ; i < this.$data.order.list.length ; i++) {
                    totalPrice += Number(this.$data.order.list[i].total_price);
                }
                this.$data.order.total_price = totalPrice;
                if(this.$data.order.service_charge_rate > 0) {
                    this.$data.order.service_charge_amount = Number(totalPrice*this.$data.order.total_price/100).toFixed(2);
                }
                this.$data.order.total_due = Number(this.$data.order.total_price) + Number(this.$data.order.service_charge_amount);

            },
            isOptionToShow: function(id) {
                // console.log("isOptionToShow " + id);
                // console.log(this.$data.currentMerchantItem.options)
                if(this.$data.currentMerchantItem.options == null || this.$data.currentMerchantItem.options == undefined || this.$data.currentMerchantItem.options.length == 0) {
                    return false;
                }
                for(let i = 0 ; i < this.$data.currentMerchantItem.options.length ; i++) {
                    if(this.$data.currentMerchantItem.options[i].id == id){
                        // console.log(this.$data.currentMerchantItem.options[i]);
                        if(this.$data.currentMerchantItem.options[i].content.required != undefined && this.$data.currentMerchantItem.options[i].content.required == true) {
                            return true;
                        }
                      if(this.$data.currentMerchantItem.options[i].content.always_show != undefined && this.$data.currentMerchantItem.options[i].content.always_show == true) {
                          return true;
                      }
                    }
                }
                return false;
            },
            shouldShowOptionSelectionView: function(item) {
                // console.log("shouldShowOptionSelectionView")
                if(item.description == null || item.description == undefined) {
                    return false;
                }

                // let list = JSON.parse(content);

                if(item.description.options == undefined) {
                    return false;
                }

                // console.log(item.description.options);
                item.options = [];
                let optionAvailable = false;
                for(let i = 0 ; i < item.description.options.length ; i++) {
                    let optionId = item.description.options[i].id;
                    let optionItem = this.getOptionSelectionItem(optionId);
                    if(optionItem != null) {

                        item.options.push(optionItem)
                        optionAvailable = true;
                    }
                }
                if(optionAvailable == true) {
                   this.$data.optionSelectItem = item;
                   return true;
                }
                return false;

            },
            getOptionSelectionItem: function(optionId) {
                if(this.$data.currentMerchantItem.options == null || this.$data.currentMerchantItem.options == undefined || this.$data.currentMerchantItem.options.length == 0) {
                   return null;
                }
                for(let i = 0 ; i < this.$data.currentMerchantItem.options.length ; i++) {
                    if (this.$data.currentMerchantItem.options[i].id == optionId) {
                        let item = JSON.parse(JSON.stringify(this.$data.currentMerchantItem.options[i].content));
                        item.name = this.$data.currentMerchantItem.options[i].name;
                        item.public_name = this.$data.currentMerchantItem.options[i].public_name;
                        if(item.list != undefined && item.list.length > 0) {
                            for(let j = 0 ; j < item.list.length ; j++) {
                                item.list[j].selected = false;
                            }
                        }
                        return item;
                    }
                }
                return null;
            },
            checkIfOptionToShow: function(optionId, item) {
                // console.log(this.$data.currentMerchantItem.options);
                for(let i = 0 ; i < item.description.options.length ; i++) {
                    if(item.description.options[i].id == optionId) {
                        return true;
                    }
                }
                return false;
            },
            isOptionSelected: function(item, optionItem, optionName) {
                // console.log("isOptionSelected " + optionName);
                // console.log(optionItem);
                if(item.option_selection == undefined) {
                    return false;
                }
                // console.log(item.option_selection);
                for(let i = 0 ; item.option_selection.length ; i++) {
                    // console.log("selection " + i);
                    // console.log(item.option_selection[i]);
                    if(item.option_selection[i].option === optionName && item.option_selection[i].field === optionItem.field_name) {
                        return true;
                    }
                }
                return false;
            },
            selectOption: function(item, optionItem, option) {
                let optionSelect =  {
                    option: option.name,
                    field: optionItem.field_name,
                    price: optionItem.field_price,

                };
                item.option_selection.push(optionSelect);
                // console.log("Select Option")
                // console.log(item.option_selection)
            },
            toggleOption: function(index, oi) {

                // Multiple choice is possible

                if (this.optionSelectItem.options[index].choice == 0) {
                    this.optionSelectItem.options[index].list[oi].selected = !this.optionSelectItem.options[index].list[oi].selected;
                }
                // Only single Choice
                else {
                    for (let i = 0; i < this.optionSelectItem.options[index].list.length; i++) {
                        this.optionSelectItem.options[index].list[i].selected = oi == i ? true : false;
                    }
                }
                this.optionSelectionItemPrice();

            },
            optionSelectionChangeAmount: function(diff) {
                this.optionSelectItem.amount += diff;
                if(this.optionSelectItem.amount <= 0) {
                    this.optionSelectItem.amount = 1;
                }
                this.optionSelectionItemPrice();
            },
            optionSelectionItemPrice: function() {
                this.optionSelectItem.optionPrice = 0;
                for(let i = 0 ; i < this.optionSelectItem.options.length ; i++) {
                    if(this.optionSelectItem.options[i].list == undefined || this.optionSelectItem.options[i].list.length == 0) {
                        continue;
                    }

                    for(let j = 0 ; j < this.optionSelectItem.options[i].list.length ; j++) {
                        if(this.optionSelectItem.options[i].list[j].selected == true) {
                            if(this.optionSelectItem.options[i].list[j].field_price != undefined) {
                                this.optionSelectItem.optionPrice += this.optionSelectItem.options[i].list[j].field_price;
                            }
                        }
                    }
                }

                this.optionSelectItem.total_price = (this.optionSelectItem.price + this.optionSelectItem.optionPrice) * this.optionSelectItem.amount;
                // console.log("Total PRice " + this.optionSelectItem.total_price);
            },
            addToOrder: function() {
                this.addOrderItem(JSON.parse(JSON.stringify(this.optionSelectItem)));
                this.optionSelectItem = false;
            },
            itemAmountChanged: function(diff, index) {
                if(this.$data.order == false) {
                    return;
                }

                if(this.$data.order.list == undefined || this.$data.order.list.length == 0 || this.$data.order.list.length <= index) {
                    return;
                }

                // console.log(this.$data.order.list);
                if(this.$data.order.list[index].amount + diff <= 0) {
                    this.confirmDeleteItem(index);
                    return;
                }

                this.$data.order.list[index].amount += diff;
                this.$data.order.list[index].total_price = (this.$data.order.list[index].price + this.$data.order.list[index].optionPrice) * this.$data.order.list[index].amount;
                this.calculatePrice();

            },
            getMenuAmount: function(menu) {
                if(this.$data.order == false) {
                    return '';
                }

                if(this.$data.order.list == undefined || this.$data.order.list.length == 0) {
                    return '';
                }
                let amount = 0;
                for(let i = 0 ; i < this.$data.order.list.length ; i++) {
                    if(this.$data.order.list[i].menu_id == menu.id) {
                        amount+=this.$data.order.list[i].amount;
                    }
                }

                if(amount == 0) {
                    return '';
                }
                return amount;
            },
            confirmDeleteItem: function(index) {
                // console.log("confirmDeleteItem");
                let self = this;
                this.showPopup("", "Remove " + this.$data.order.list[index].menu_name + "?",
                                "Remove", "No",
                                function(){
                                  self.$data.order.list.splice(index, 1);
                                  self.calculatePrice();
                                })
            },
            getTodayOpeningTime: function(item) {
              if(item.openingTime == null || item.openingTime.length == 0) {
                // console.log(item.openingTime);
                // console.log("No opening time information " + item.title);
                return false;
              }
              let openingTime = JSON.parse(item.openingTime);

              item.openSlots = [];
              item.isOpen = false;
              if(openingTime != null && openingTime.length > 0) {
                let today = new Date();
                let dayOfWeek = today.getDay();
                let time = openingTime[dayOfWeek];
                if(time != undefined && time != null) {
                  item.isOpen = time.open;
                  if (item.isOpen == true && time.times != undefined && time.times != null && time.times.length > 0) {
                    // this.$data.slots = time.times;

                    for (let i = 0; i < time.times.length; i++) {

                      let from = time.times[i].from;
                      let to = time.times[i].to;


                      today.setHours(Number(from.split(':')[0]));
                      today.setMinutes(Number(from.split(':')[1]));

                      let fromMil = today.getTime();

                      today.setHours(Number(to.split(':')[0]));
                      today.setMinutes(Number(to.split(':')[1]));

                      let toMil = today.getTime();

                      let slot = {
                        from: fromMil,
                        to: toMil,
                        fromString: from,
                        toString: to,
                      };
                      item.openSlots.push(slot);
                    }
                  }
                }
              }
              return true;
            },
          showMenus: function(type) {
            this.$data.menuView = {
              merchant: this.$data.merchantItem,
              type:type,
            }
          },
          closeMenuView: function() {
            this.$data.menuView = false;
          },
          getThumbnamil: function(url, size = 300) {
            if(url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/merchants/menus") || url.startsWith("https://storage.googleapis.com/menus-275719.appspot.com/webs/")) {
              let words = url.split('.');
              words[words.length-2] += '_' + size + 'x' + size;
              return words.join('.');
            }
            return url;
          },
          openMenuFile: function(url) {
            window.open(url, '_blank');
          }
        }
    }
</script>

<style scoped>
.merchant-title {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 30px;
  font-weight: bold;
}
.home-main-image {
  height: 670px;
}
.home-main-subtitle {
  font-size: 30px;
  padding:50px;
  width: 100%;
}
@media only screen and (max-width: 430px) {
  .home-main-image {
    height: 600px;
  }
  .home-main-subtitle {
    width: 90%;
    font-size: 15px;
    padding:10px;
  }
}

.top-nav-container {
  width: 100%; position: absolute; padding: 20px; z-index: 10;
  color:white;
  background-color: transparent;
  transition: background-color 0.5s ease-in-out;
}
.top-nav-container.dark {
  background-color: rgba(0,0,0,1);
}
@media only screen and (max-width: 500px) {
  .top-nav-container {
    padding: 20px 0;
  }
}
.home-main-overlay {
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
}

.home-main-title {
  font-weight: 400;
  font-size: 40px;
  line-height: 48px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.3em;
  margin-right: -0.3em;

  color: #FFFFFF;
}
.home-main-description {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.2em;
  margin-right: -0.2em;

  color: #FFFFFF;
}
.home-main-order-btn {
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.2em;

  color: #000000;
  background: #FFFFFF;
  padding: 18px 25px;
  transition: background-color 0.3s ease-in-out;
}
.home-main-order-btn:hover {
  background-color: #DBDBDB;
}
@media only screen and (max-width: 500px) {
  .home-main-title{
    font-size: 30px;
  }
  .home-main-description {
    font-size: 18px;
  }
  .home-main-order-btn {
    font-size: 14px;
  }
}
.restaurant-menu-button {
  border: 1px solid #000000;
  background-color: white;
  width: 300px;
  padding: 24px 0;
  font-weight: 500;
  font-size: 18px;
  line-height: 36px;
  /* identical to box height */

  text-align: center;
  letter-spacing: 0.1em;
  text-transform: uppercase;

  cursor: pointer;
  color: #000000;
  margin: 10px;

}
.restaurant-menu-button:hover {
  background-color: #ECECEC;
}
a {
  text-decoration: none;
  color: inherit;
}
.even-item-container {
    display: flex; align-items: center; justify-content: center;
}
.home-main-title-image {
  text-align: center;
  padding: 20px;
}
.home-main-title-image img {

  width: 100%;
  max-width: 350px;
  margin: auto;
}
@media only screen and (max-width: 430px) {
    .even-item-container {
      display: block;
    }
    .even-item-container .restaurant-menu-button {
        margin:10px auto 10px auto;
        padding: 20px 0;
        width: calc(100% - 32px);
        text-align: center;
        font-size: 18px;

    }
    .home-main-title-image {
      //max-width: 80%;
    }

}
.place-bottom-container > p {
  margin-bottom: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue